import { Component, OnInit,ViewChild,Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController } from '@ionic/angular';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.page.html',
  styleUrls: ['./invoice.page.scss'],
})

export class InvoicePage implements OnInit {

@ViewChild('input', {static: false}) searchInput: { setFocus: () => void; } ;

  name:any;
  qty:any;
  price:any;
  data:any =[];
  type:any = 0;
  title:any;
  url:any;
  logo:any;
  products:any;
  product:any;
  text:any;

  constructor(public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

   this.type  = this.route.snapshot.paramMap.get('type');
   this.text  = JSON.parse(localStorage.getItem(Constant.appText));
   this.title = this.type == 0 ? this.text.create_invoice : this.text.create_offer;

   if(!localStorage.getItem(Constant.userId) || localStorage.getItem(Constant.userId) == undefined || localStorage.getItem(Constant.userId) == 'null')
    {
      this.nav.navigateRoot('/home');
    }

  }

  ngOnInit()
  {

  }

  ionViewDidEnter()
  {
    if(localStorage.getItem(Constant.products) && localStorage.getItem(Constant.products) != undefined && localStorage.getItem(Constant.products) != 'null')
    {
      this.data = JSON.parse(localStorage.getItem(Constant.products));
    }

    this.getProduct();

  }

  getName()
  {
    for(var i =0;i<this.products.length;i++)
    {
      if(this.products[i].id == this.product)
      {
        this.name  = this.products[i].name;
        this.price = this.products[i].price;
        this.qty   = 1;
      }
    }
  }

  addProduct()
  {
    if(!this.name || !this.qty || !this.price)
    {
      return this.presentToast(this.text.pro_error);
    }

    var pdata = {name : this.name,qty:this.qty,price:this.price}

    this.data.push(pdata);

    this.name  = null;
    this.qty   = null;
    this.price = null;

    return this.presentToast(this.text.pro_success);
  }

  async getProduct()
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.getProduct().subscribe((response:any) => {

    this.products = response.data;

    console.log(response.plan);

    if(!response.plan.valid_till)
    {
      this.presentToast(this.text.plan_expire);

      this.nav.navigateForward('/account');
    }

    loading.dismiss();

    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }

  conti()
  {
    if(this.name && this.qty && this.price)
    {
      this.addProduct();

      localStorage.setItem(Constant.products, JSON.stringify(this.data));

      this.nav.navigateForward('/client/'+this.type);
    }
    else
    {
      localStorage.setItem('products', JSON.stringify(this.data));

      this.nav.navigateForward('/client/'+this.type);
    }
  }

  async remove() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.text.are_you_sure,
      message: this.text.remove_product,
      mode : 'ios',
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          cssClass: 'secondary',
          id: 'cancel-button',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: this.text.cancel,
          id: 'confirm-button',
          handler: () => {

          localStorage.setItem(Constant.products,null);
          this.data = [];

          }
        }
      ]
    });

    await alert.present();
  }
}
